module.exports = __webpack_public_path__ + "static/img/zhsq_img.81094a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhsq_img.png
// module id = Ug5i
// module chunks = 52